import { UseCaseInteractor } from '../../../kernel/use-case'
import { Job } from '../domain/job'
import { JobRepository } from '../domain/job.repository'

export const getJobUseCase: UseCaseInteractor<[jobRepository: JobRepository], [uuid: string], Job> =
  (jobRepository: JobRepository) =>
  async (uuid: string): Promise<Job> => {
    return jobRepository.getJob(uuid)
  }
